<ion-content class="ion-padding" [hidden]="sso?.redirect?.enabled && !overrideLogin">
  <div class="login-container">
    <ion-grid>
      <ion-row>
        <ion-col size="12" size-md="6">
          <form class="form" [formGroup]="formGroup">
            <h1>{{ 'login.welcome' | translate | uppercase }}</h1>
            <h2>{{ 'login.doLogin' | translate }}</h2>

            <ng-container *ngIf="sso.enabled">
              <div *ngIf="!platform.is('capacitor')" class="button">
                <a [href]="apiUrl+'/api/account/login/sso'">
                  {{ 'login.loginSSO' | translate }}
                </a>
              </div>

              <div *ngIf="platform.is('capacitor')" class="button">
                <a (click)="loginOAuth()">
                  {{ 'login.loginSSO' | translate }}
                </a>
              </div>
            </ng-container>

            <!-- <div class="spacer"></div>
            <div class="spacer"> Ou </div>
            <div class="spacer"></div> -->

            <a
              *ngIf="sso.enabled"
              class="standard-login"
              style="cursor: pointer"
              (click)="standardLogin = true"
            >
              {{ 'login.standardLogin' | translate }}
            </a>

            <ng-container *ngIf="standardLogin || !sso.enabled">
              <mat-form-field class="login-input">
                <input
                  matInput
                  required
                  placeholder="Username/Email"
                  formControlName="username"
                />
              </mat-form-field>
              <control-messages
                class="login-input"
                [control]="formGroup.get('username')"
              ></control-messages>

              <mat-form-field class="login-input">
                <input
                  matInput
                  type="password"
                  required
                  [placeholder]="'generic.password' | translate"
                  formControlName="password"
                />
              </mat-form-field>
              <control-messages
                class="login-input"
                [control]="formGroup.get('password')"
              ></control-messages>

              <a style="cursor: pointer" (click)="forgotPass()">
                {{ 'login.forgotPassword' | translate }}
              </a>

              <div class="spacer"></div>
              <mat-progress-bar
                *ngIf="loading"
                mode="indeterminate"
              ></mat-progress-bar>
              <div class="spacer"></div>
              <button (click)="doLogin()">
                {{ 'login.login' | translate }}
              </button>
            </ng-container>
          </form>
        </ion-col>
        <ion-col size="12" size-md="6">
          <div class="ilustration" [style.background-image]="'url(' + loginImgPath + ')'"></div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
